import { FormViewModeType } from '@baserow/modules/database/formViewModeTypes'
import FormViewModePreviewForm from '@baserow/modules/database/components/view/form/FormViewModePreviewForm'

import FormViewModeEncuesta from '@extras_mg/components/FormViewModeEncuesta'

/**
 * Modo encuesta: el formulario publico pregunta de una en una.
 *
 * Nombre propio (encuesta_mg): el "survey" de premium sigue registrado y sigue
 * pidiendo licencia; este aparece a su lado y funciona.
 *
 * La vista previa del editor es la del core, la misma que usa el modo normal:
 * ahi se configuran los campos y el orden, que es identico en los dos modos. Lo
 * que cambia —una pregunta a la vez— se ve al abrir el formulario compartido.
 */
export class FormViewModeEncuestaType extends FormViewModeType {
  static getType() {
    return 'encuesta_mg'
  }

  getName() {
    return 'Encuesta'
  }

  getDescription() {
    return 'Una pregunta a la vez, con barra de avance.'
  }

  getIconClass() {
    return 'iconoir-reports'
  }

  isDeactivated() {
    return false
  }

  getPreviewComponent() {
    return FormViewModePreviewForm
  }

  getFormComponent() {
    return FormViewModeEncuesta
  }
}
